module.exports = __webpack_public_path__ + "static/media/landing_page_video_4k.09143107.mp4";